export class GenerateDepositResponse {
    public depositId: number;
    public depositType?: number;
    public boletoInfo: BoletoInfo;
    public pixInfo: PixInfo;
}

export class BoletoInfo {
    public createDate: Date;
    public nossoNumero: string;
    public digitalLine: string;
    public codeBar: string;
    public value: number;
    public dueDate?: Date;
    public diffValue?: number;
    public payValue?: number;
    public status: number;
    public depositId: number;
    public pdf: string;
}

export class PixInfo {
    public BrCodeImage: string;
    public BRCode: string;
    public BrCodeNumber: string;
    public Identifier: number;
}